import CustomFormulaDialog from "../../common/fields/custom-field/CustomFormulaDialog.tsx";
import type { FormulaReferenceField } from "../../common/fields/custom-field/utilities/customFormulaParser.ts";
import { fixedCurrenciesOnly } from "../utils/statementFormat.ts";
import type { StatementFormula } from "../utils/statementFormulas.ts";
import { toFormulaDialogField, toStatementFormula } from "../utils/statementFormulas.ts";

interface Props {
  source: StatementFormula;
  referableFields: FormulaReferenceField[];
  referableFieldsTitle?: string;
  allowGrandTotal?: boolean;
  getReferenceError?: (formulaParameters: string[]) => string | undefined;
  onClose: () => void;
  onApply: (formula: StatementFormula) => void;
}

const StatementFormulaDialog = ({
  source,
  referableFields,
  referableFieldsTitle,
  allowGrandTotal,
  getReferenceError,
  onClose,
  onApply,
}: Props) => (
  <CustomFormulaDialog
    open
    onClose={onClose}
    onApply={(data) => onApply(toStatementFormula(data))}
    editedField={toFormulaDialogField(source)}
    referableFields={referableFields}
    referableFieldsTitle={referableFieldsTitle}
    allowGrandTotal={allowGrandTotal}
    currencyDimensions={fixedCurrenciesOnly}
    getReferenceError={getReferenceError}
  />
);

export default StatementFormulaDialog;
